import { RootState } from '../../store';

export const getFormErrorsSelector = (state: RootState) => state?.categoryReducer?.formErrors;
